// This is to be used for Angular DatePipe
export class DateFormat {
    public static readonly DateTime = 'MM/dd/yy HH:mm:ss';
    public static readonly DateTime12Hour = 'MM/dd/yy h:mm aa';
    public static readonly DateTimeShort = 'shortDate';
    public static readonly DefaultTimezone = 'America/New_York';
    public static readonly FullDate = 'fullDate';
    public static readonly LongDate = 'longDate';
    public static readonly LsqShort = 'MM/dd/yyyy';
    public static readonly LsqShortYear = 'MM/dd/yy';
    public static readonly LsqShortYearDashed = 'MM-dd-yy';
    public static readonly LastUpdatedTime = 'hh:mm';
    public static readonly MediumDate = 'mediumDate';
    public static readonly MonthAndYear = 'MMMM y';
    public static readonly ShortMonthAndYear = 'MMM y';
    public static readonly Short = 'short';
    public static readonly ShortMonth = 'MMM';
    public static readonly ShortTime = 'shortTime';
    public static readonly LongTime = "MM/dd/yy 'at' h:mm aaa 'ET'";
    public static readonly YearOnly = 'YYYY';
    public static readonly ISO8601 = 'YYYY-MM-dd';
}

// This is to be used for the DateFns library
export class DateFnsFormat {
    public static readonly SentenceFormat = 'MMMM D, YYYY';
    public static readonly ShortFormat = 'MM/DD/YY';
    public static readonly TimeFormat = 'hh:mm aa';
    public static readonly ApiDateTimeFormat = 'YYYY/MM/DD HH:mm:ss';
}
